import useSelector from "Hooks/useSelector";
import _ from "lodash";

/**
 * @deprecated Use useSelector from "Hooks/useSelector" directly instead.
 * This wrapper preserves the old default of _.isEqual for backward compatibility.
 */
const useReduxState = (selector, equalityFn = _.isEqual) => {
  return useSelector(selector, equalityFn);
};

export default useReduxState;
